module.exports = __webpack_public_path__ + "img/Speaker=Josh Sirefman.db944954.png";